
export { DMS_MODULE, PART_RETURN_REQUEST as NAME } from '../../constants';
export const CRUMB_LABEL_KEY = 'PartReturnRequest';
export const ZAKAZKA_ND = 'ZakazkaNd';
export const PART_RETURN_REQ_DETAILS = 'PartReturnReqDetails';
export const DEPENDENT_TABLES_ALL = <const>[
	ZAKAZKA_ND,
	PART_RETURN_REQ_DETAILS,
];
export const NEW_COL_START_COUNT = 500;
export const PART_NUMBER_REF_COLUMN = 3;
export const PART_NUMBER_COLUMN = 10;
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];

export enum PART_RETURN_STATUS {
	APPROVE = 1,
	PENDING = 2,
	REJECTED = 3,
}

export enum PART_RETURN_REASONS {
	OTHER = 'Others',
	INCORRECT_PART = 'Incorrect part'
}

export const PART_NO = 'PART_NO';
export const ND_NR = 'ND_NR';

export const GRID_COLUMNS = {
	PART_NO,
	ND_NR,
};
